import React, { useStyles } from "react";
import { styleAlertBox } from "../../styles/alerts";

export const AlertBox = ({ message, type = "success", onClose, title = null }) => {
  const classes = styleAlertBox(); // Usa el hook de estilos

  return (
    <div className={classes.overlay}>
      <div className={classes.alertBox}>
        <h3 className={classes.title}>
          { title ? title : (type === "error" ? "¡Error!" : "¡Éxito!")}
        </h3>
        <p className={classes.message}>{message}</p>
        <button className={classes.button} onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default AlertBox;
